import CryptoJS from "crypto-js";

// Secret key - must match the server's key
const SECRET_KEY = "c54f48f6d3934bfc";

export class CryptoService {
  static decrypt(encryptedData) {
    if (typeof encryptedData !== "string") {
      throw new Error("Encrypted data must be a string");
    }

    // Trim whitespace and validate Base64 format
    const trimmedData = encryptedData.trim();
    const base64Regex = /^[A-Za-z0-9+/=]+$/;

    if (!base64Regex.test(trimmedData)) {
      console.error("Invalid Base64 Data:", trimmedData);
      throw new Error("Encrypted data is not valid Base64");
    }

    try {
      const bytes = CryptoJS.AES.decrypt(trimmedData, SECRET_KEY);
      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedString) {
        throw new Error("Decryption resulted in an empty string");
      }

      return JSON.parse(decryptedString);
    } catch (error) {
      console.error("Decryption failed:", error);
      throw new Error("Failed to decrypt data from server");
    }
  }

  static createSecureFetch() {
    return async (url, options = {}) => {
      try {
        const response = await fetch(url, options);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const responseText = await response.text();
        console.log("Received Encrypted Data:", responseText); // Log received data

        // Always attempt decryption first, then fall back to JSON parsing
        try {
          return this.decrypt(responseText.trim());
        } catch (decryptError) {
          // If decryption fails, assume it's unencrypted JSON
          return JSON.parse(responseText);
        }
      } catch (error) {
        console.error("Error processing response:", error);
        throw error;
      }
    };
  }
}